import { render, staticRenderFns } from "./ResourcesTeamManage.vue?vue&type=template&id=7f854f7a"
import script from "./ResourcesTeamManage.vue?vue&type=script&lang=js"
export * from "./ResourcesTeamManage.vue?vue&type=script&lang=js"
import style0 from "./ResourcesTeamManage.vue?vue&type=style&index=0&id=7f854f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports